import { render } from "./add.vue?vue&type=template&id=47763360&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=47763360&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47763360"]])

export default __exports__